import React, {useMemo, useRef, useState} from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {Tooltip} from 'primereact/tooltip';


const DependentsPartial = ({dependents}) => {

    const DependentsColumns = useMemo(
        () => [
            {
                header: 'Policy',
                field: 'policy_number',
            },
            {
                header: 'Name',
                field: 'name',
            },
            {
                header: 'Surname',
                field: 'surname',
            },
            {
                header: 'D.O.B',
                field: 'date_of_birth'
            },
            {
                header: 'Gender',
                field: 'gender'
            },
            {
                header: 'Person Type',
                field: 'person_type'
            },
            {
                header: 'Relationship',
                field: 'relationship'
            },
            {
                header: 'Premium',
                field: 'premium'
            },
            {
                header: "Created At",
                field: "created_at"
            },
            {
                header: 'Updated At',
                field: 'updated_at',
            },
        ],
        []
    )

    // const [dependents, setDependents] = useState([])

    const [selectedData, setSelectedData] = useState([])
    const dt = useRef(null);

    const exportColumns = DependentsColumns.map(col => ({title: col.header, dataKey: col.field}));

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({selectionOnly});
    }

    const exportPdf = () => {
        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default('l', "mm");
                doc.autoTable({
                    showHead: 'firstPage',
                    columns: exportColumns,
                    body: dependents,
                    styles: {overflow: 'linebreak', columnWidth: 'wrap', cellPadding: 1, fontsize: 6},
                    columnStyles: {
                        0: {columnWidth: 20},
                        1: {columnWidth: 20},
                        2: {columnWidth: 20},
                        3: {columnWidth: 20},
                        6: {columnWidth: 20},
                        7: {columnWidth: 22},
                        9: {columnWidth: 20}
                    }
                });
                doc.save('dependents_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear() + '.pdf');
            })
        })
    }


    const exportExcel = () => {
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(dependents);
            const workbook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
            const excelBuffer = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
            saveAsExcelFile(excelBuffer, 'dependents_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear());
        });
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(module => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear() + EXCEL_EXTENSION);
            }
        });
    }

    const onSelectionChange = (e) => {
        setSelectedData(e.value);
    }


    const header = (
        <div className="flex align-items-center export-buttons">
            <Button type="button" icon="pi pi-file" onClick={() => exportCSV(false)}
                    className="mr-2 p-button-secondary p-button-sm" data-pr-tooltip="CSV"/>
            <Button type="button" icon="pi pi-file-excel" onClick={exportExcel}
                    className="p-button-dark mr-2 p-button-sm" data-pr-tooltip="XLS"/>
            <Button type="button" icon="pi pi-file-pdf" onClick={exportPdf} className="p-button-danger mr-2 p-button-sm"
                    data-pr-tooltip="PDF"/>
            <Button type="button" icon="pi pi-filter" onClick={() => exportCSV(true)}
                    className="p-button-info ml-auto p-button-sm" data-pr-tooltip="Export Selection Only"/>
        </div>
    );

    // const footer = `In total there are ${data ? data.length : 0} commissions.`;

    /**
     *  Filter Modes
     */



    const filters = {

        'policy_number': {
            operator: FilterOperator.OR,
            constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
        },
    }


    return (
        <>
            {/*    tabs*/}
            <div className="card">
                <h5 className="title h3 px-4">Dependents</h5>

                <Tooltip target=".export-buttons>button" position="bottom"/>

                <DataTable value={dependents} responsiveLayout="scroll" header={header}
                           paginator
                           paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                           rowsPerPageOptions={[5, 10, 15]}
                           currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                           rows={5}
                           sortMode="multiple" filters={filters} filterDisplay="menu"
                           resizableColumns
                           ref={dt}
                           dataKey="id"
                           scrollable scrollHeight="700px"
                           selection={selectedData} onSelectionChange={onSelectionChange}
                           selectionMode="checkbox"
                           name={'dependents_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear()}
                >
                    <Column selectionMode="multiple"/>
                    <Column field="policy_number" header="Policy Number" filter
                            style={{minWidth: '12rem'}}></Column>
                    <Column field="name" header="Name"></Column>
                    <Column field="surname" header="Surname"></Column>
                    <Column field="gender" header="Gender"></Column>
                    <Column style={{minWidth: '14rem'}} field="person_type" header="Person Type"></Column>
                    <Column style={{minWidth: '14rem'}} field="relationship" header="Relationship"></Column>
                    <Column field="premium" header="Premium"></Column>
                    <Column style={{minWidth: '10rem'}} field="date_of_birth" header="Date of Birth"></Column>
                </DataTable>
            </div>
            {/*    end tabs*/}
        </>
    )

}

export default DependentsPartial
